import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

interface MessageDataPoint {
  date: string;
  total: number;
  promotional: number;
  transactional: number;
}

interface MessageTrendsChartProps {
  data: MessageDataPoint[];
}

export const MessageTrendsChart: React.FC<MessageTrendsChartProps> = ({ data }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Message Trends</h3>
      </div>

      <div className="w-full h-72">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="total" stroke="#3B82F6" strokeWidth={2} name="Total" />
            <Line type="monotone" dataKey="promotional" stroke="#F97316" strokeWidth={2} name="Promotional" />
            <Line type="monotone" dataKey="transactional" stroke="#10B981" strokeWidth={2} name="Transactional" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
